import { SearchResultProperty } from './search-result-property';

export class SearchResult {
    index: string;
    key: string;
    type: string;
    searchResultProperties: Array<SearchResultProperty> = new Array();
    constructor(key?:string, type?: string, index?: string, searchResultProperties?: Array<SearchResultProperty>) {
        this.key = key;
        this.type = type;
        if (searchResultProperties) {
            this.searchResultProperties = searchResultProperties;
        }
    }
}